import { ModalId } from "../../../enums/modalId";
import { setOpenedModalId } from "../../../redux/slice/modalSliceNew";

export const assignRecordClick = (dispatch: any, rowData?: any) => {
  dispatch(
    setOpenedModalId({
      id: ModalId.ASTERA_PRIMARY_CARE_SUBMISSION_MODAL,
      metaData: { rowData: rowData ?? {} },
    }),
  );
};
